import React, { FC } from 'react';
import { AssetTypes } from 'types/Common';
import { StandardCover } from 'types/Cover';
import { ARROW_ANCHOR } from 'components/Lane/Lane.css';
import { ImageWrapper } from 'components/Cards/Card/Card.css';
import { CardVariant, cardSpec } from 'components/Cards/Card/cardVariants';
import { coverChannelImage } from 'components/Cards/Card/cardCover';
import { CardChannelLogo } from './CardChannelLogo';
import { CardFavoriteBadge } from './CardFavoriteBadge';
import { CardMedia } from './CardMedia';
import { CardOverlays } from './CardOverlays';
import { CardPlayButton } from './CardPlayButton';

type PropTypes = {
    variant: CardVariant;
    asset: StandardCover;
    blurBackdrop?: boolean;
    showProgress?: boolean;
    srLabel?: string;
};

export const CardBody: FC<PropTypes> = ({ variant, asset, blurBackdrop = false, showProgress = true, srLabel }) => {
    const spec = cardSpec(variant);
    const { onPlayIconClicked, renderPlayIcon, progressBar, image, customImage, contentMarker, landscape, rawData, isFavorite } = asset;

    return (
        <ImageWrapper {...{ [ARROW_ANCHOR]: '' }}>
            {srLabel && <span className="sr-only">{srLabel}</span>}
            <CardFavoriteBadge visible={asset?.assetType === AssetTypes.now_next && isFavorite} />
            <CardPlayButton visible={renderPlayIcon} onPlay={onPlayIconClicked} />
            <CardMedia
                image={image}
                customImage={customImage}
                landscape={landscape}
                fallbackImage={spec.fallbackImage}
                insetFallbackImage={spec.insetFallbackImage}
                showInsetPortrait={spec.showInsetPortrait}
                blurBackdrop={blurBackdrop}
            />
            <CardOverlays progressBar={progressBar} contentMarker={contentMarker} showProgress={showProgress} />
            <CardChannelLogo src={coverChannelImage(asset)} channelName={asset.channelName ? '' : rawData?.channelName} />
        </ImageWrapper>
    );
};
